import { useQuery } from '@tanstack/react-query';
import { getUaePassStatus } from '../lib/auth-api';

export const UAE_PASS_STATUS_QUERY_KEY = ['auth', 'uae-pass', 'status'] as const;

export function useUaePassStatus(enabled = true) {
  return useQuery({
    queryKey: UAE_PASS_STATUS_QUERY_KEY,
    queryFn: getUaePassStatus,
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}
